import React, { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import Spinner from "../common/spinner";
import { ToastContainer, toast } from "react-toastify";
import "./reservedOrders.scss";
import * as service from "./reservedOrdersServices";
import {
  timestampToDateFull,
  log,
  getMapIdBasedonEnvironment,
} from "../../helper/helper";

import decodePolyline from "decode-google-map-polyline";
import origin from "../../assets/origin.png";
import destination from "../../assets/destination.png";

import { GoogleMap, Marker, Polyline } from "@react-google-maps/api";
import { Col, Row } from "antd";

function ReservedOrders(props) {
  const customerUserId = props.history.location.customerUserId
    ? props.history.location.customerUserId
    : "";
  const [transports, setTransports] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [positions, setPositions] = useState([]);
  const [map, setMap] = React.useState(null);
  const [totalPaidBearers, setTotalPaidBearers] = useState("0.00");
  const [totalPaidCustomers, setTotalPaidCustomers] = useState("0.00");
  const [selectedIds, setSelectedIds] = useState([]);
  const onLoadBounds = (map) => {
    if (!map) {
      return;
    }
    const bounds = new window.google.maps.LatLngBounds();
    positions.forEach((child) => {
      bounds.extend(new window.google.maps.LatLng(child.lat, child.lng));
    });
    map.fitBounds(bounds);
    setMap(map);
  };

  const defaultMapOptions = {
    fullscreenControl: true,
  };

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  const containerStyle = {
    width: "100%",
    height: "50vh",
  };

  const options = {
    fillColor: "lightblue",
    fillOpacity: 1,
    strokeColor: "blue",
    strokeOpacity: 1,
    strokeWeight: 2,
    clickable: false,
    draggable: false,
    editable: false,
    geodesic: false,
    zIndex: 1,
  };

  const loadGoogleMap = () => {
    return (
      <GoogleMap
        mapContainerStyle={containerStyle}
        zoom={13}
        onLoad={onLoadBounds}
        onUnmount={onUnmount}
        defaultOptions={defaultMapOptions}
        options={{
          mapId: getMapIdBasedonEnvironment(),
        }}
      >
        {positions.map((marker) => (
          <Marker
            position={marker}
            key={marker.lat + marker.lng + Math.random()}
            icon={{
              url: marker.icon,
            }}
          />
        ))}
        {transports.map((trip, idx) => (
          <Polyline
            key={`polyline-${idx}`}
            path={decodePolyline(trip.overview_polyline)}
            options={options}
          />
        ))}
        <></>
      </GoogleMap>
    );
  };

  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (!user) {
        return props.history.replace("/login");
      }
      adminGetReservedOrdersListApilntegration();
    });
  }, []);

  useEffect(() => {
    const filtered =
      selectedIds.length > 0
        ? transports.filter((t) => selectedIds.includes(t.transport_id))
        : transports;

    const bearersTotal = filtered.reduce(
      (sum, t) => sum + (parseFloat(t.original_payable_to_rider) || 0),
      0
    );

    const customersTotal = filtered.reduce(
      (sum, t) => sum + (parseFloat(t.transport_receivable_price) || 0),
      0
    );

    setTotalPaidBearers(bearersTotal.toFixed(2));
    setTotalPaidCustomers(customersTotal.toFixed(2));
  }, [selectedIds, transports]);

  const renderSpinner = () => {
    if (isLoading) {
      return <Spinner />;
    }
  };

  const handleTransportDate = (time) => {
    return timestampToDateFull(time);
  };

  const adminGetReservedOrdersListApilntegration = async () => {
    setLoading(true);
    try {
      const result = await service.adminGetReservedOrdersListApiIntegration(
        customerUserId
      );
      setLoading(false);
      log(result);
      if (result) {
        setLoading(false);
        switch (result.data.code) {
          case 200:
            const list = [...transports, ...result.data.transportList];
            setTransports(list);
            let positionsData = [];
            for (const trip of result.data.transportList) {
              positionsData.push(
                {
                  lat: trip.origin_lat,
                  lng: trip.origin_lng,
                  icon: origin,
                  zIndex: 9,
                },
                {
                  lat: trip.destination_lat,
                  lng: trip.destination_lng,
                  icon: destination,
                  zIndex: 9,
                }
              );
            }
            setPositions(positionsData);
            return;
          case 401:
            toast.error(result.data.message);
            return props.history.replace("/login");
          case 500:
            return toast.error(result.data.message);
          default:
            return toast.error(result.data.message);
        }
      }
    } catch (error) {
      log(error);
      toast.error(error.message);
    }
    setLoading(false);
  };

  return (
    <div className="show-all-list data-server-list">
      <ToastContainer />
      {renderSpinner()}
      {positions.length > 0 && <div className="map"> {loadGoogleMap()}</div>}
      <div style={{ padding: "20px 0" }}>
        <Row gutter={16}>
          <Col span="12">
            <div
              style={{
                fontSize: 16,
                fontWeight: "bold",
                textAlign: "center",
                color: "#f00",
              }}
            >
              Total Paid to Bearers: {totalPaidBearers}
            </div>
          </Col>
          <Col span="12">
            <div
              style={{
                fontSize: 16,
                fontWeight: "bold",
                textAlign: "center",
                color: "#71cf9a",
              }}
            >
              Total Paid to Customers: {totalPaidCustomers}
            </div>
          </Col>
        </Row>
      </div>
      <h6 style={{ margin: "20 0" }}>
        Found {transports.length} {transports.length > 1 ? "results" : "result"}
      </h6>
      <table className="table">
        <thead>
          <tr>
            <th>Creation Date / Time</th>
            <th>Client Order No</th>
            <th>Origin Address</th>
            <th>Customer Name</th>
            <th>Destination Address</th>
            <th>Distance</th>
            <th>Final Paid by Customer</th>
            <th>Original Payable to Rider</th>
          </tr>
        </thead>
        <tbody>
          {transports.map((transport) => (
            <tr key={transport.transport_id}>
              <td>{handleTransportDate(transport.transport_creation_time)}</td>
              <td>{transport.client_order_number}</td>
              <td>{transport.origin_address}</td>
              <td>{transport.business_name}</td>
              <td>{transport.destination_address}</td>
              <td>{transport.transport_length}</td>
              <td>{"A$ " + transport.transport_receivable_price}</td>
              <td>{"A$ " + transport.original_payable_to_rider}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
export default ReservedOrders;
